export const LEAD_SOURCE_OPTIONS = [
  'Seminars',
  'Walk-In',
  'Instagram',
  'Referral',
  'Website',
  'Google Ads',
  'Meta Ads',
  'YouTube',
  'LinkedIn',
  'Social Media',
] as const;

export type LeadSourceOption = (typeof LEAD_SOURCE_OPTIONS)[number];

export const DEFAULT_LEAD_SOURCE: LeadSourceOption = 'Website';

export function resolveLeadSource(value?: string | null): LeadSourceOption {
  const trimmed = value?.trim();
  if (trimmed && (LEAD_SOURCE_OPTIONS as readonly string[]).includes(trimmed)) {
    return trimmed as LeadSourceOption;
  }
  return DEFAULT_LEAD_SOURCE;
}
